import Vue from "@/main";
import store from "@/store/store";
import stockImage from "@/http/requests/stockImage";

export default {
  fetch({ commit }) {
    return new Promise((resolve, reject) => {
      stockImage.fetch().then(response => {
        commit('SET_STOCK_IMAGES', response.data.data.stockImages)

        Vue.$events.off('StockImageChanged')
        Vue.$events.on('StockImageChanged', (stock) => {
          if ( stock.type.includes('created') ){
            commit('ADD_STOCK_IMAGES', stock.image);
          } else {
            commit('DELETE_STOCK_IMAGES', stock.image.id);
          }
        });

        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, image) {
    return new Promise((resolve, reject) => {
      stockImage.add({url: image.url, caption: image.caption}).then((response) => {
        commit('ADD_STOCK_IMAGES',response.data.data.createStockImage)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      stockImage.delete(id).then(() => {
        commit('DELETE_STOCK_IMAGES', id)
        resolve()
      })
      .catch((error) => { reject(error) })
    })
  },
}
